export default {
      id: "events-usage",
      viewBox: "0 0 67 74",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#events-usage",
      toString: function () {
        return this.url;
      }
    }